import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { VSnackbar, VBtn, VIcon } from "vuetify/lib";
import VuetifyToast from "vuetify-toast-snackbar";

import AddFile from "@/components/icons/AddFile";
import AddPerson from "@/components/icons/AddPerson";
import AngFlag from "@/components/icons/AngFlag";
import AnnouncementIcon from "@/components/icons/Announcement";
import ApplauseReactionIcon from "@/components/icons/ApplauseReaction";
import ApplauseReactionSmallIcon from "@/components/icons/ApplauseReactionSmall";
import ArrowDownIcon from "@/components/icons/ArrowDown";
import Attachment from "@/components/icons/Attachment";
import BigTick from "@/components/icons/BigTick";
import BookmarkIcon from "@/components/icons/Bookmark";
import CalendarIcon from "@/components/icons/Calendar";
import Camera from "@/components/icons/Camera";
import CarrotIcon from "@/components/icons/Carrot";
import Certificate from "@/components/icons/Certificate";
import ChartBarIcon from "@/components/icons/ChartBar";
import ChevronDownIcon from "@/components/icons/ChevronDown";
import CommentIcon from "@/components/icons/Comment";
import CommentOffIcon from "@/components/icons/CommentOff";
import CommissionedTask from "@/components/icons/CommissionedTask";
import CompanyIcon from "@/components/icons/Company";
import Delete from "@/components/icons/Delete";
import DownloadIcon from "@/components/icons/Download";
import Edit from "@/components/icons/Edit";
import EditInput from "@/components/icons/EditInput";
import ExclamationIcon from "@/components/icons/Exclamation";
import FaceIcon from "@/components/icons/Face";
import FaceReactionIcon from "@/components/icons/FaceReaction";
import FaceReactionSmallIcon from "@/components/icons/FaceReactionSmall";
import FileAddIcon from "@/components/icons/FileAdd";
import FileEditIcon from "@/components/icons/FileEdit";
import FileIcon from "@/components/icons/File";
import FilePlus from "@/components/icons/FilePlus";
import ForwardIcon from "@/components/icons/Forward";
import GifIcon from "@/components/icons/GifIcon";
import GroupsIcon from "@/components/icons/Groups";
import HandIcon from "@/components/icons/Hand";
import HeadphonesIcon from "@/components/icons/Headphones";
import HeartIcon from "@/components/icons/Heart";
import HeartReactionIcon from "@/components/icons/HeartReaction";
import HelpIcon from "@/components/icons/Help";
import HomeIcon from "@/components/icons/Home";
import IdeaIcon from "@/components/icons/Idea";
import LikeIcon from "@/components/icons/Like";
import LikeSmall from "@/components/icons/LikeSmall";
import ListIcon from "@/components/icons/List";
import MessageIcon from "@/components/icons/Message";
import MessageOffIcon from "@/components/icons/MessageOffIcon";
import NotificationIcon from "@/components/icons/Notification";
import NotificationOffIcon from "@/components/icons/NotificationOff";
import PauseIcon from "@/components/icons/Pause";
import PhotoIcon from "@/components/icons/Photo";
import Plus from "@/components/icons/Plus";
import PolandFlag from "@/components/icons/PolandFlag";
import PostIcon from "@/components/icons/Post";
import QueueIcon from "@/components/icons/Queue";
import ReceivedTask from "@/components/icons/ReceivedTask";
import RevertIcon from "@/components/icons/Revert";
import RewindIcon from "@/components/icons/Rewind";
import SetPriority from "@/components/icons/SetPriority";
import ShareIcon from "@/components/icons/Share";
import StarIcon from "@/components/icons/Star";
import Tag from "@/components/icons/Tag";
import TaskCompleted from "@/components/icons/TaskCompleted";
import TaskDeadlineDate from "@/components/icons/TaskDeadlineDate";
import TaskDeadlineToday from "@/components/icons/TaskDeadlineToday";
import TaskDeadlineTomorrow from "@/components/icons/TaskDeadlineTomorrow";
import TaskList from "@/components/icons/TaskList";
import Tick from "@/components/icons/Tick";
import TodoIcon from "@/components/icons/TodoIcon";
import Upload from "@/components/icons/Upload";
import VideoIcon from "@/components/icons/Video";
import VolumeIcon from "@/components/icons/Volume";
import WorldIcon from "@/components/icons/World";
import AddImageIcon from "@/components/icons/AddImage";
import InfoIcon from "@/components/icons/Info";
import SettingsIcon from "@/components/icons/Settings";
import EmptyAvatarIcon from "@/components/icons/EmptyAvatar"
import BanIcon from "@/components/icons/Ban"
import TrashIcon from "@/components/icons/Trash"
import AdminStarIcon from "@/components/icons/AdminStar"
import Envelope from "@/components/icons/Envelope";
import ExternalLink from "@/components/icons/ExternalLink";
import BookOpenIcon from "@/components/icons/BookOpen";
import MonitorIcon from "@/components/icons/Monitor";
import TrendingUpIcon from "@/components/icons/TrendingUp";

import pl from "@/assets/lang/pl";
import en from "@/assets/lang/en";

Vue.use(Vuetify, {
	components: {
		VSnackbar,
		VBtn,
		VIcon,
	},
	iconfont: "mdi",
});

Vue.use(VuetifyToast);
import config from '@/config/sou.config.js'

export default new Vuetify({
	lang: {
		locales: {
			pl,
			en,
		},
		current: "pl",
	},
	dark: false,
	theme: config.theme,
	icons: {
		values: {
			"arrow-down": {
				component: ArrowDownIcon,
			},
			bookmark: {
				component: BookmarkIcon,
			},
			calendar: {
				component: CalendarIcon,
			},
			"chart-bar": {
				component: ChartBarIcon,
			},
			"chevron-down": {
				component: ChevronDownIcon,
			},
			company: {
				component: CompanyIcon,
			},
			"file-edit": {
				component: FileEditIcon,
			},
			forward: {
				component: ForwardIcon,
			},
			groups: {
				component: GroupsIcon,
			},
			headphones: {
				component: HeadphonesIcon,
			},
			help: {
				component: HelpIcon,
			},
			home: {
				component: HomeIcon,
			},
			list: {
				component: ListIcon,
			},
			notification: {
				component: NotificationIcon,
			},
			pause: {
				component: PauseIcon,
			},
			queue: {
				component: QueueIcon,
			},
			rewind: {
				component: RewindIcon,
			},
			volume: {
				component: VolumeIcon,
			},
			announcement: {
				component: AnnouncementIcon,
			},
			"comment-off": {
				component: CommentOffIcon,
			},
			comment: {
				component: CommentIcon,
			},
			download: {
				component: DownloadIcon,
			},
			exclamation: {
				component: ExclamationIcon,
			},
			face: {
				component: FaceIcon,
			},
			"face-reaction": {
				component: FaceReactionIcon,
			},
			hand: {
				component: HandIcon,
			},
			heart: {
				component: HeartIcon,
			},
			"heart-reaction": {
				component: HeartReactionIcon,
			},
			idea: {
				component: IdeaIcon,
			},
			like: {
				component: LikeIcon,
			},
			"like-small": {
				component: LikeSmall,
			},
			message: {
				component: MessageIcon,
			},
			"message-off": {
				component: MessageOffIcon,
			},
			"notification-off": {
				component: NotificationOffIcon,
			},
			photo: {
				component: PhotoIcon,
			},
			share: {
				component: ShareIcon,
			},
			star: {
				component: StarIcon,
			},
			video: {
				component: VideoIcon,
			},
			"file-add": {
				component: FileAddIcon,
			},
			carrot: {
				component: CarrotIcon,
			},
			world: {
				component: WorldIcon,
			},
			post: {
				component: PostIcon,
			},
			file: {
				component: FileIcon,
			},
			gif: {
				component: GifIcon,
			},
			revert: {
				component: RevertIcon,
			},
			plus: {
				component: Plus,
			},
			tick: {
				component: Tick,
			},
			delete: {
				component: Delete,
			},
			"add-person": {
				component: AddPerson,
			},
			"add-file": {
				component: AddFile,
			},
			"set-priority": {
				component: SetPriority,
			},
			"big-tick": {
				component: BigTick,
			},
			attachment: {
				component: Attachment,
			},
			"task-deadline-today": {
				component: TaskDeadlineToday,
			},
			"task-deadline-tomorrow": {
				component: TaskDeadlineTomorrow,
			},
			"task-deadline-date": {
				component: TaskDeadlineDate,
			},
			"commissioned-task": {
				component: CommissionedTask,
			},
			"received-task": {
				component: ReceivedTask,
			},
			upload: {
				component: Upload,
			},
			"edit-input": {
				component: EditInput,
			},
			tag: {
				component: Tag,
			},
			"task-completed": {
				component: TaskCompleted,
			},
			"task-list": {
				component: TaskList,
			},
			"todo-icon": {
				component: TodoIcon,
			},
			edit: {
				component: Edit,
			},
			"applause-reaction": {
				component: ApplauseReactionIcon,
			},
			"applause-reaction-sm": {
				component: ApplauseReactionSmallIcon,
			},
			"face-reaction-sm": {
				component: FaceReactionSmallIcon,
			},
			"file-plus": {
				component: FilePlus,
			},
			"ang-flag": {
				component: AngFlag,
			},
			"pl-flag": {
				component: PolandFlag,
			},
			camera: {
				component: Camera,
			},
			certificate: {
				component: Certificate,
			},
			"add-image": {
				component: AddImageIcon
			},
			"info": {
				component: InfoIcon
			},
			"empty-avatar": {
				component: EmptyAvatarIcon
			},

			"ban": {
				component: BanIcon
			},
			"trash": {
				component: TrashIcon
			},
			"admin-star": {
				component: AdminStarIcon
			},
			settings: {
				component: SettingsIcon
			},
			"envelope": {
				component: Envelope
			},
			"external-link": {
				component: ExternalLink
			},
			"book-open": {
				component: BookOpenIcon
			},
			"monitor": {
				component: MonitorIcon
			},
			"trending-up": {
				component: TrendingUpIcon
			}
		},
	},
});
